import { Container } from '@mui/material';
import React, { FC } from 'react';
import IframeComponent from 'src/components/ui-component/i-frame/IframeComponent ';
import ScrollToTop from '../../../components/layout/ScrollToTop';

const Datenschutz: FC<{}> = () => {
	return (
		<>
			<ScrollToTop />
			<Container>
				<IframeComponent src='https://datenschutzgenerator.hessen-agentur.de/projekt.cfm?pid=28' />
			</Container>
		</>
	);
};
export default Datenschutz;

// <Typography variant='h2' component={'h1'}>
// Datenschutz
// </Typography>
// <br></br>
// <Stack direction={'row'} spacing={2}>
// 	<Stack flex={1} spacing={2}>
// 		<Box>
// 			<Typography variant='h5' component={'h2'}>
// 				Anbieter
// 			</Typography>
// 			<Typography>
// 				Die <b>Verantwortliche</b> im Sinne der EU Datenschutz-Grundverordnung, des Hessischen Datenschutz- und Informationsfreiheitsgesetzes
// 				(HDSIG) und anderer nationaler Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist:
// 			</Typography>
// 		</Box>
// 		<Typography variant='h5' component={'h2'}>
// 			HA Hessen Agentur GmbH
// 		</Typography>
// 		<Box>
// 			<Typography>Mainzer Str. 118</Typography>
// 			<Typography>65189 Wiesbaden</Typography>
// 			<Typography>Tel. +49 611 9501780</Typography>
// 			<Typography>Fax +49 611 950178466</Typography>
// 			<Typography>
// 				E-Mail: <Link href={'mailto:info@hessen-agentur.de'}>info@hessen-agentur.de</Link>
// 			</Typography>
// 		</Box>
// 		<Box>
// 			<Typography variant='h5' component={'h2'}>
// 				Vertreten durch die Geschäftsführer:
// 			</Typography>
// 			<Typography>
// 				<Box>
// 					<Typography>Folke Mühlhölzer (Vorsitzender) </Typography>
// 					<Typography>Dr. Rainer Waldschmidt </Typography>
// 				</Box>
// 			</Typography>
// 		</Box>
// 		<Typography variant='h5' component={'h2'}>
// 			Registergericht und -nummer:
// 		</Typography>
// 		<Typography>Amtsgericht Wiesbaden, HRB 21418</Typography>
// 		<Typography variant='h5' component={'h2'}>
// 			Umsatzsteuer-Identifikationsnummer:
// 		</Typography>
// 		<Typography>DE 237911160</Typography>
// 		<Typography>
// 			Die <b>Datenschutzbeauftragte</b> der Verantwortlichen erreichen Sie wie folgt:
// 		</Typography>
// 		<Box>
// 			<Typography>SCHIEDERMAIR Beratungsgesellschaft für Datenschutz mbH</Typography>
// 			<Typography>Eschersheimer Landstraße 60</Typography>
// 			<Typography>60322 Frankfurt am Main</Typography>
// 			<Typography>
// 				E-Mail: <Link href={'mailto:datenschutzbeauftragter@hessen-agentur.de'}>datenschutzbeauftragter@hessen-agentur.de</Link> oder{' '}
// 				<Link href={'mailto:info@schiedermair-datenschutz.com'}>info@schiedermair-datenschutz.com</Link>{' '}
// 			</Typography>
// 			<Typography>Telefon: + 49 69 95508-400</Typography>
// 			<Typography>Telefax: + 49 69 95508-401</Typography>
// 		</Box>
// 		<br></br>
// 		<Box>
// 			<Typography variant='h5' component={'h2'}>
// 				Personenbezogene Daten
// 			</Typography>
// 			<Typography>
// 				Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen; als
// 				identifizierbar wird eine natürliche Person angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung zu einer Kennung wie
// 				einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung oder zu einem oder mehreren besonderen Merkmalen
// 				identifiziert werden kann, die Ausdruck der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen oder
// 				sozialen Identität dieser natürlichen Person sind.
// 			</Typography>
// 		</Box>
// 		<Typography>Wir beschreiben nachfolgend, wie wir Ihre personenbezogenen Daten verarbeiten.</Typography>

// 		<Typography>1.</Typography>
// 		<Typography>
// 			<b>
// 				Speicherung personenbezogener Daten in unserem Customer Relationship Management-System Beschreibung und Umfang der Datenverarbeitung:
// 			</b>
// 			Wenn Sie mit uns geschäftlich in Kontakt treten, speichern wir ggf. Ihre personenbezogenen Daten in unserem Customer Relationship
// 			Management-System und informieren Sie ggf. in unregelmäßigen Abständen über aktuelle Themen aus unserem Tätigkeitsbereich und
// 			Veranstaltungen (kein Newsletter).
// 		</Typography>
// 		<Typography>
// 			Die Bereitstellung der personenbezogenen Daten durch Sie ist weder gesetzlich noch vertraglich vorgeschrieben noch für einen
// 			Vertragsabschluss erforderlich. Sie sind nicht verpflichtet, uns personenbezogene Daten bereitzustellen.
// 		</Typography>
// 		<Typography>
// 			<b>Rechtsgrundlage für die Datenverarbeitung:</b> Rechtsgrundlage für die Datenverarbeitung ist der uns übertragene öffentliche Auftrag
// 			der Wirtschaftsförderung im Land Hessen (Art. 6 Abs. 1 lit. e DS-GVO).
// 		</Typography>
// 		<Typography>
// 			<b>Zweck der Datenverarbeitung:</b> Die Verarbeitung der personenbezogenen Daten dient der Organisation unserer geschäftlichen Kontakte
// 			sowie der Zusendung von Informationen im Rahmen der Erfüllung des uns übertragenen öffentlichen Auftrags der Wirtschaftsförderung in
// 			Hessen.
// 		</Typography>
// 		<Typography>
// 			<b>Dauer der Speicherung:</b> Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
// 			erforderlich sind. Wir prüfen regelmäßig, spätestens alle drei Jahre, ob eine weitere Speicherung der Daten erforderlich ist. Dies gilt
// 			nicht, sofern der Löschung gesetzliche oder vertragliche Verpflichtungen, insbesondere Aufbewahrungsfristen, entgegenstehen.
// 		</Typography>
// 		<br></br>
// 		<Typography>2.</Typography>
// 		<Typography>
// 			<b>Bereitstellung der Webseite und Erstellung von Logfiles:</b>
// 			Bei jedem Aufruf unserer Internetseiten erfasst unser System automatisiert Daten und Informationen vom Computersystem des aufrufenden
// 			Rechners.
// 		</Typography>
// 		<Typography>
// 			<b>Beschreibung und Umfang der Datenverarbeitung:</b> Folgende Informationen werden bei einem Seitenaufruf automatisch von Ihrem System
// 			erhoben:
// 		</Typography>
// 		<Typography component={'ul'}>
// 			<Typography component={'li'}>Browsertyp und -version</Typography>
// 			<Typography component={'li'}>verwendetes Betriebssystem</Typography>
// 			<Typography component={'li'}>Webseite, von der aus Sie uns besuchen (Referrer URL)</Typography>
// 			<Typography component={'li'}>Webseite, die Sie besuchen</Typography>
// 			<Typography component={'li'}>Datum und Uhrzeit Ihres Zugriffs</Typography>
// 			<Typography component={'li'}>verwendete Internet Protokoll (IP)-Adresse</Typography>
// 		</Typography>
// 		<Typography>
// 			Die Erfassung und Speicherung der Systeminformationen in Logfiles ist für den Betrieb der Webseite zwingend erforderlich.
// 		</Typography>
// 		<Typography>
// 			<b>Rechtsgrundlage für die Datenverarbeitung:</b> Rechtsgrundlage für die vorübergehende Speicherung der Informationen und der Logfiles
// 			ist Art. 6 Abs. 1 lit. f DS-GVO.
// 		</Typography>
// 		<Typography>
// 			<b>Zweck der Datenverarbeitung:</b> Die vorübergehende Speicherung der von Ihnen verwendeten IP-Adresse ist notwendig, um eine
// 			Auslieferung der Webseite an Ihren Rechner zu ermöglichen. Zweck der Speicherung in Logfiles ist es, die Funktionsfähigkeit und
// 			Stabilität der Webseite und unseres IT-Systems sicherzustellen. Eine Auswertung der Daten zu Marketingzwecken findet in diesem
// 			Zusammenhang nicht statt. In den dargestellten Zwecken liegt auch unser berechtigtes Interesse an der Datenverarbeitung nach Art. 6 Abs.
// 			1 lit. f DS-GVO.
// 		</Typography>
// 		<Typography>
// 			<b>Dauer der Speicherung:</b> Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
// 			erforderlich sind. Im Falle der Erfassung der Daten zur Bereitstellung der Webseite ist dies der Fall, wenn die jeweilige Sitzung
// 			beendet ist. Die in Logfiles gespeicherten Daten werden spätestens nach einer Frist von sieben Tagen gelöscht.
// 		</Typography>
// 		<Typography>3.</Typography>
// 		<Typography>
// 			<b>Kontaktaufnahme per E-Mail Beschreibung und Umfang der Datenverarbeitung:</b> Wenn Sie über die bereitgestellte E-Mail-Adresse mit
// 			uns Kontakt aufnehmen, werden die mit der E-Mail übermittelten personenbezogenen Daten gespeichert.
// 		</Typography>
// 		<Typography>
// 			Im Rahmen der Bearbeitung Ihrer E-Mail-Anfrage kann es erforderlich sein, dass wir weitere Daten und Informationen bei Ihnen erfragen.
// 			Sofern Sie uns in einem solchen Fall die weitergehenden Informationen nicht bereitstellen wollen, hat dies keine nachteiligen Folgen. Es
// 			ist jedoch möglich, dass die unterbliebene Bereitstellung der angeforderten Informationen die Bearbeitung Ihrer Anfrage erschwert oder
// 			unmöglich macht. Sollten Sie uns gegenüber zur Auskunft verpflichtet sein, weisen wir Sie hierauf durch eine gesonderte Erklärung hin,
// 			in der wir Sie auf gegebenenfalls bestehende rechtlich nachteilige Folgen einer durch Sie unterbliebenen Auskunft aufmerksam machen.
// 		</Typography>
// 		<Typography>
// 			Zur Beantwortung Ihrer Fragen kann es je nach Sachlage erforderlich sein, Daten zu Ihrer Person auch an andere Stellen innerhalb der
// 			Landesverwaltung, Bundes- oder kommunale Behörden oder an die Wirtschaftsförderungsgesellschaften des Landes Hessen (HA Agentur GmbH,
// 			Hessen Trade & Invest GmbH und LEA LandesEnergieAgentur Hessen GmbH) weiterzuleiten. Soweit die Anfrage die Versorgung mit digitaler
// 			Infrastruktur betrifft, kann es erforderlich sein, personenbezogenen Daten an das jeweils zuständige Telekommunikationsunternehmen
// 			weiterzuleiten. Falls Sie mit einer Weiterleitung, die nicht nur das zuständige Fachministerium betrifft, nicht einverstanden sind,
// 			teilen Sie uns dies bitte mit.
// 		</Typography>
// 		<Typography>
// 			Sollten wir für Ihr Anliegen nicht zuständig sein, leiten wir Ihre Eingabe an die zuständige Stelle weiter und informieren Sie darüber,
// 			sofern das Ihrem Anliegen entspricht.
// 		</Typography>
// 		<Typography>
// 			<b>Rechtsgrundlage für die Datenverarbeitung:</b> Rechtsgrundlage für die Verarbeitung der Daten, die im Zuge einer Übersendung einer
// 			E-Mail übermittelt werden, ist Art. 6 Abs. 1 lit. e DS-GVO i.V.m. § 3 Abs. 1 HDSIG, wenn wir mit der Bearbeitung Ihrer E-Mail-Anfrage
// 			eine im öffentlichen Interesse liegende Aufgabe wahrnehmen oder Art. 6 Abs. 1 lit. f DS-GVO. Unser berechtigtes Interesse liegt darin,
// 			Ihre an uns gerichtete E-Mail-Anfrage zu beantworten. Zielt der E-Mail-Kontakt auf den Abschluss eines Rechtsverhältnisses ab oder
// 			erfolgt im Zusammenhang mit einem bestehenden Rechtsverhältnis zu uns, so ist zusätzliche Rechtsgrundlage für die Verarbeitung Art. 6
// 			Abs. 1 lit. b DS-GVO.
// 		</Typography>
// 		<Typography>
// 			<b>Zweck der Datenverarbeitung:</b> Die Verarbeitung der personenbezogenen Daten aus einer E-Mail dient uns allein zur Bearbeitung der
// 			E-Mail-Anfrage.
// 		</Typography>
// 		<Typography>
// 			<b>Dauer der Speicherung:</b> Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
// 			erforderlich sind. Für die personenbezogenen Daten, die per E-Mail übersandt wurden, ist dies dann der Fall, wenn die jeweilige
// 			Konversation mit Ihnen beendet ist. Beendet ist die Konversation dann, wenn sich aus den Umständen entnehmen lässt, dass der betroffene
// 			Sachverhalt abschließend geklärt ist. Dies gilt nicht, sofern der Löschung gesetzliche oder vertragliche Verpflichtungen, insbesondere
// 			Aufbewahrungsfristen für aktenrelevante Vorgänge, entgegenstehen. Es gelten die Fristen in dem aktuellen Erlass zur Aktenführung in den
// 			Dienststellen des Landes Hessen; diese Frist beträgt regelmäßig fünf Jahre.
// 		</Typography>
// 		<br></br>
// 		<Typography>4.</Typography>
// 		<Typography>
// 			<b>Kontaktformular</b>
// 		</Typography>
// 		<Typography>
// 			<b>Beschreibung und Umfang der Datenverarbeitung:</b> Mit Absenden einer Kontaktanfrage über ein Kontaktformular werden die in der
// 			Eingabemaske eingegeben Daten an uns übermittelt und gespeichert. Im Zeitpunkt der Absendung der Nachricht werden zudem die von Ihnen
// 			verwendete IP-Adresse sowie Datum und Uhrzeit der Kontaktanfrage gespeichert.
// 		</Typography>
// 		<Typography>
// 			Im Rahmen der Bearbeitung Ihrer Kontaktanfrage kann es erforderlich sein, dass wir weitere Daten und Informationen bei Ihnen erfragen.
// 			Sofern Sie uns in einem solchen Fall die weitergehenden Informationen nicht bereitstellen wollen, hat dies keine nachteiligen Folgen. es
// 			ist jedoch möglich, dass die unterbliebene Bereitstellung der angeforderten Informationen die Bearbeitung Ihrer Anfrage erschwert oder
// 			unmöglich macht. Sollten Sie dem Hessischen Ministerium für Digitalisierung und Innovation gegenüber zur Auskunft verpflichtet sein,
// 			weisen wir Sie hierauf durch eine gesonderte Erklärung hin, in der wir Sie auf gegebenenfalls bestehende rechtlich nachteilige Folgen
// 			einer durch Sie unterbliebenen Auskunft aufmerksam machen.
// 		</Typography>
// 		<Typography>
// 			Zur Beantwortung Ihrer Fragen kann es je nach Sachlage erforderlich sein, Daten zu Ihrer Person auch an andere Stellen innerhalb der
// 			Landesverwaltung, Bundes- oder kommunale Behörden oder an die Wirtschaftsförderungsgesellschaften des Landes Hessen (Hessen Trade &
// 			Invest GmbH und Hessen Agentur GmbH) weiterzuleiten. Soweit die Anfrage die Versorgung mit digitaler Infrastruktur betrifft, kann es
// 			erforderlich sein, personenbezogenen Daten an das jeweils zuständige Telekommunikationsunternehmen weiterzuleiten. Unter Umständen kann
// 			es auch erforderlich sein, Ihre Daten an andere Stellen innerhalb der Landesverwaltung, Bundes- oder kommunale Behörden weiterzuleiten.
// 			Falls Sie mit einer Weiterleitung, die nicht nur das zuständige Fachministerium betrifft, nicht einverstanden sind, teilen Sie uns dies
// 			bitte unbedingt mit, indem Sie das dafür vorgesehene Optionsfeld in dem Online-Formular entsprechend aktivieren.
// 		</Typography>
// 		<Typography>
// 			Sollten wir für Ihr Anliegen nicht zuständig sein, leiten wir Ihre Eingabe an die zuständige Stelle weiter und informieren Sie darüber,
// 			sofern das Ihrem Anliegen entspricht.
// 		</Typography>
// 		<Typography>
// 			<b>Rechtsgrundlage für die Datenverarbeitung:</b> Rechtsgrundlage für die Verarbeitung der Daten, die im Zuge einer Mitteilung über das
// 			Kontaktformular übermittelt werden, ist Art. 6 Abs. 1 lit. e DS-GVO i.V.m. § 3 Abs. 1 HDSIG, wenn wir mit der Bearbeitung eine im
// 			öffentlichen Interesse liegende Aufgabe wahrnehmen oder Art. 6 Abs. 1 lit. f DS-GVO. Unser berechtigtes Interesse liegt darin, Ihre an
// 			uns gerichtete Kontaktanfrage zu bearbeiten. Zielt die Mitteilung über das Kontaktformular auf den Abschluss eines Rechtsverhältnisses
// 			ab oder erfolgt im Zusammenhang mit einem bestehenden Rechtsverhältnis zu uns, so ist zusätzliche Rechtsgrundlage für die Verarbeitung
// 			Art. 6 Abs. 1 lit. b DS-GVO.
// 		</Typography>
// 		<Typography>
// 			<b>Zweck der Datenverarbeitung:</b> Die Verarbeitung der personenbezogenen Daten aus der Eingabemaske oder einer E-Mail dient uns allein
// 			zur Bearbeitung der Kontaktanfrage.
// 		</Typography>
// 		<Typography>
// 			<b>Dauer der Speicherung:</b> Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
// 			erforderlich sind. Für die personenbezogenen Daten aus der Eingabemaske des Kontaktformulars ist dies dann der Fall, wenn die jeweilige
// 			Konversation mit dem Nutzer beendet ist. Beendet ist die Konversation dann, wenn sich aus den Umständen entnehmen lässt, dass der
// 			betroffene Sachverhalt abschließend geklärt ist. Dies gilt nicht, sofern der Löschung gesetzliche oder vertragliche Verpflichtungen,
// 			insbesondere Aufbewahrungsfristen, entgegenstehen. Es gelten die Fristen in dem aktuellen Erlass zur Aktenführung in den Dienststellen
// 			des Landes Hessen; diese Frist beträgt regelmäßig fünf Jahre.
// 		</Typography>
// 		<Typography>
// 			Die während des Absendevorgangs zusätzlich erhobenen personenbezogenen Daten werden spätestens nach einer Frist von sieben Tagen
// 			gelöscht.
// 		</Typography>
// 		<Typography>
// 			<b>Übermittlung personenbezogener Daten:</b> Empfänger Ihrer personenbezogenen Daten sind unsere mit der jeweiligen Vorgangsbearbeitung
// 			betrauten Beschäftigten. Eine Weitergabe Ihrer Daten erfolgt nur im Rahmen der Vorgaben des geltenden Rechts oder der von Ihnen
// 			erteilten Einwilligung, so dass dafür Sorge getragen wird, dass Ihre Daten nicht an Unberechtigte gelangen.
// 		</Typography>
// 		<Typography>
// 			Unsere Webseiten und Auftritte in den sozialen Medien sowie Veranstaltungen und sonstige Projekte werden zum Teil von den
// 			Wirtschaftsförderungsgesellschaften Hessens realisiert. In diesem Zusammenhang erhält die jeweils beauftragte Gesellschaft
// 			personenbezogene Daten. Die Wirtschaftsförderungsgesellschaften sind projektbezogen von uns beauftragt. Je nach Inhalt und Organisation
// 			des Projekts wird die beauftragte Wirtschaftsförderungsgesellschaft auf unsere Weisung hin auf Basis eines
// 			Auftragsverarbeitungsvertrages tätig.
// 		</Typography>
// 		<Typography>
// 			Zur Bearbeitung von Angelegenheiten kann es je nach Sachlage erforderlich sein, Daten zu Ihrer Person auch an andere Stellen innerhalb
// 			der Bundes-, Landes- oder kommunalen Verwaltung weiterzuleiten. Soweit eine Angelegenheit die Versorgung mit digitaler Infrastruktur
// 			betrifft, kann es notwendig sein, personenbezogene Daten an das jeweils zuständige Telekommunikationsunternehmen zu übermitteln.
// 		</Typography>
// 		<Typography>
// 			Darüber hinaus erhalten nur solche externe Stellen Ihre Daten, die wir als Dienstleister auf Grundlage eines
// 			Auftragsverarbeitungsvertrages beauftragt haben.{' '}
// 		</Typography>
// 		<Typography>
// 			Liegt keine Auftragsverarbeitung vor, ist Rechtsgrundlage für die Datenübermittlung Art. 6 Abs. 1 lit. e DSGVO, §§ 21, 22 HDSIG, soweit
// 			nicht speziellere Rechtsgrundlagen einschlägig sind und in diesen Datenschutzhinweisen im Rahmen bestimmter Verarbeitungsprozessen
// 			darauf hingewiesen wird.
// 		</Typography>
// 		<br></br>
// 		<Typography>5.</Typography>
// 		<Typography>
// 			<b>Meldeformular für nicht barrierefreie Inhalte</b>
// 		</Typography>
// 		<Typography>
// 			<b>Beschreibung und Umfang der Datenverarbeitung:</b> Mit Absenden des bereitgestellten Formulars für die Meldung nicht barrierefreier
// 			Inhalte auf unserem Internet-Angebot werden die von Ihnen eingegebenen Daten an uns übermittelt und gespeichert. Im Zeitpunkt der
// 			Absendung werden zudem die von Ihnen verwendete IP-Adresse sowie Datum und Uhrzeit der Meldung gespeichert.
// 		</Typography>
// 		<Typography>
// 			Die Bereitstellung der Daten durch Sie ist freiwillig. Die Nichtbereitstellung hat, soweit es sich hierbei um Pflichtangaben handelt,
// 			zur Folge, dass eine Bearbeitung der Meldung im Zweifel nicht möglich ist.
// 		</Typography>
// 		<Typography>
// 			<b>Rechtsgrundlage für die Datenverarbeitung:</b> Mit dem Meldeformular erfüllen wir unsere gesetzliche Pflicht zur Bereitstellung eines
// 			barrierefreien Internet-Angebots und der elektronischen Meldung von bestehenden Barrieren gem. Art. 6 Abs. 1 lit. c DS-GVO i.V.m. § 4
// 			Abs. 2 Nr. 2 Hessische Verordnung über barrierefreie Informationstechnik (HVBIT).
// 		</Typography>
// 		<Typography>
// 			<b>Zweck der Datenverarbeitung:</b> Die Verarbeitung der personenbezogenen Daten aus dem Meldeformular dient uns ausschließlich zur
// 			Bearbeitung Ihrer Meldung.
// 		</Typography>
// 		<Typography>
// 			<b>Dauer der Speicherung:</b> Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
// 			erforderlich sind. Für die personenbezogenen Daten aus der Eingabemaske des Meldeformulars ist dies dann der Fall, wenn die jeweilige
// 			Meldung bei uns aufgenommen ist und Ihnen innerhalb der gesetzlichen Pflicht (derzeit sechs Wochen) geantwortet wurde. Danach werden die
// 			Daten gelöscht, sofern der Löschung nicht gesetzliche oder vertragliche Verpflichtungen, insbesondere Aufbewahrungsfristen,
// 			entgegenstehen. Die während des Absendevorgangs zusätzlich erhobenen personenbezogenen Daten werden spätestens nach einer Frist von
// 			sieben Tagen gelöscht.
// 		</Typography>
// 		<br></br>
// 		<Typography>6.</Typography>
// 		<Typography>
// 			<b>Anmeldung für Veranstaltungen</b>
// 		</Typography>
// 		<Typography>
// 			<b>Beschreibung und Umfang der Datenverarbeitung:</b> Mit Absenden einer Anmeldung über ein Anmeldeformular werden die in der
// 			Eingabemaske eingegeben Daten und abgegebenen Erklärungen an uns übermittelt und gespeichert. Im Zeitpunkt der Absendung der Anmeldung
// 			werden zudem die von Ihnen verwendete IP-Adresse sowie Datum und Uhrzeit der Anmeldung gespeichert.
// 		</Typography>
// 		<Typography>
// 			Falls in die Veranstaltung externe Referenten einbezogen sind, geben wir Ihre Daten erforderlichenfalls zum Zwecke der Vorbereitung und
// 			Durchführung der Veranstaltung an diese externen Referenten weiter.
// 		</Typography>
// 		<Typography>
// 			Die Bereitstellung der personenbezogenen Daten durch Sie ist freiwillig. Die Bereitstellung der als Pflichtangaben gekennzeichneten
// 			Daten ist allerdings erforderlich, damit wir eine Vereinbarung über Ihre Teilnahme an der gewünschten Veranstaltung abschließen und
// 			durchführen können.
// 		</Typography>
// 		<Typography>
// 			<b>Rechtsgrundlage für die Datenverarbeitung:</b> Rechtsgrundlage für die Verarbeitung der Daten ist Art. 6 Abs. 1 lit. b DS-GVO, da die
// 			Verarbeitung der Daten für die Anmeldung und Durchführung der von Ihnen ausgewählten Veranstaltung erforderlich ist. Falls wir gesondert
// 			Ihre Einwilligung einholen, ist Art. 6 Abs. 1 lit. a DS-GVO zudem Rechtsgrundlage.
// 		</Typography>
// 		<Typography>
// 			<b>Zweck der Datenverarbeitung:</b> Die Verarbeitung der personenbezogenen Daten dient ausschließlich der Anmeldung und Durchführung der
// 			Veranstaltung.
// 		</Typography>
// 		<Typography>
// 			<b>Dauer der Speicherung:</b> Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
// 			erforderlich sind. Die im Rahmen der Anmeldung erhobenen personenbezogenen Daten werden spätestens einen Monat nach Beendigung der
// 			Veranstaltung gelöscht, soweit Sie nicht einer weitergehenden Nutzung oder Verarbeitung zugestimmt haben (z.B. Einwilligung zum Erhalt
// 			von Einladungen für zukünftige Veranstaltungen).
// 		</Typography>
// 		<Typography>
// 			Die während des Absendevorgangs zusätzlich erhobenen personenbezogenen Daten werden spätestens nach einer Frist von sieben Tagen
// 			gelöscht.
// 		</Typography>
// 		<br></br>
// 		<Typography>7.</Typography>
// 		<Typography>
// 			<b>Aufzeichnung von Veranstaltungen</b>
// 		</Typography>
// 		<Typography>
// 			<b>Beschreibung und Umfang der Datenverarbeitung:</b> Veranstaltungen zeichnen wir zum Teil auf und bieten sie zum (Live-)Streaming auf
// 			unseren Webseiten und/oder in unseren Auftritten in sozialen Medien an, um eine Teilnahme in Echtzeit außerhalb des Veranstaltungsortes
// 			und einen späteren Abruf von Aufzeichnungen von einer Veranstaltung zu ermöglichen. Bei der Aufzeichnung von Online- und
// 			Hybrid-Veranstaltungen werden etwaige Chatbeiträge getrennt gespeichert; diese werden nicht veröffentlicht. Im Falle der
// 			Online-Teilnahme an Veranstaltungen werden zudem Verbindungsdaten (Geräteinformationen und IP-Adresse) der Teilnehmenden gespeichert.
// 			Dies ist für die Online-Teilnahme an einer Veranstaltung technisch erforderlich.
// 		</Typography>
// 		<Typography>
// 			Die Aufzeichnungen können auf unseren Webseiten und/oder Seiten bei sozialen Medien veröffentlicht werden. Damit kommen wir unserem
// 			Auftrag zur Präsentation und Dokumentation unserer Tätigkeit sowie zur Information der Öffentlichkeit nach. Für die Veröffentlichung auf
// 			Social-Media-Kanälen sowie bei Aufzeichnungen mit Porträt und Nahaufnahmen von Ihnen wird gesondert Ihre Einwilligung eingeholt und auf
// 			diese Datenschutzerklärung verwiesen.
// 		</Typography>
// 		<Typography>
// 			Für das Livestreaming von Veranstaltungen arbeiten wir regelmäßig mit externen Dienstleistern zusammen, die auf unsere Weisungen hin auf
// 			Grundlage eines Auftragsverarbeitungsvertrages für uns tätig werden.
// 		</Typography>
// 		<Typography>
// 			<b>Rechtsgrundlage für die Datenverarbeitung:</b> Rechtsgrundlage für die Verarbeitung der Daten ist Ihre Einwilligung, wenn wir im
// 			Rahmen der Aufzeichnungen Porträt/Nahaufnahmen anfertigen und diese auf Seiten in sozialen Medien veröffentlichen (Art. 6 Abs. 1 lit. a
// 			DS-GVO). Die Anfertigung und Veröffentlichung von Aufzeichnungen mit Übersichts- und Gruppenaufnahmen und solchen von Referierenden auf
// 			Webseiten erfolgt auf Grundlage unseres öffentlichen Auftrages zur Wirtschaftsförderung und Öffentlichkeitsarbeit (Art. 6 Abs. 1 lit. e
// 			DS-GVO). Rechtsgrundlage für die Speicherung der Verbindungsdaten im Falle der Online-Teilnahme an einer Veranstaltung ist Art. 6 Abs. 1
// 			lit. f DS-GVO; unser berechtigtes Interesse liegt in der Gewährleistung der Funktionsfähigkeit der Systeme zur Durchführung der
// 			Veranstaltung.
// 		</Typography>
// 		<Typography>
// 			<b>Zweck der Datenverarbeitung:</b> Die Verarbeitung der personenbezogenen Daten dient den im Abschnitt Beschreibung und Umfang der
// 			Datenverarbeitung genannten Zwecken.
// 		</Typography>
// 		<Typography>
// 			<b>Dauer der Speicherung:</b> Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
// 			erforderlich sind. Veröffentlichte Aufzeichnungen von Veranstaltungen bleiben gespeichert, so lange die jeweiligen Veröffentlichungen
// 			abrufbar oder erhältlich sind. Die Verbindungsdaten werden spätestens nach einer Frist von sieben Tagen gelöscht.
// 		</Typography>
// 		<Typography>
// 			<b>Datenübermittlung in Drittstaaten:</b> Sofern wir eine Veranstaltung aufzeichnen und/oder Sie in die Veröffentlichung von
// 			Porträt/Nahaufnahmen in sozialen
// 		</Typography>
// 	</Stack>
// 	<Stack flex={1} spacing={2}>
// 		<Typography>
// 			Medien eingewilligt haben, können die Daten an die Betreiber der sozialen Netzwerke übermittelt werden, bei denen wir eine Profilseite
// 			unterhalten und über die wir ausdrücklich informieren. Die Betreiber sozialer Medien haben Ihren Sitz teilweise außerhalb des Gebietes
// 			der EU und des Europäischen Wirtschaftsraumes (EWR), insbesondere in den USA. Diese Länder verfügen zum Teil nicht über ein der EU
// 			entsprechendes Datenschutzniveau oder die Bestätigung der Angemessenheit des Datenschutzniveaus ist von weiteren Voraussetzungen
// 			abhängig (z.B. Zertifizierung der Teilnahme am EU-U.S. Data Privacy Framework). Wir können nicht ausschließen, dass auch dann, wenn
// 			Betreiber sozialer Medien einen Sitz in der EU haben, die personenbezogenen Daten auch an Konzerngesellschaften in den USA oder in einem
// 			anderen Land außerhalb der EU oder des EWR übermittelt und/oder diese auch auf Servern in den USA oder einem anderen Land außerhalb der
// 			EU oder des EWR gespeichert werden.
// 		</Typography>

// 		<br></br>
// 		<Typography>8.</Typography>
// 		<Typography>
// 			<b>Aufnahme und Veröffentlichung von Foto- und Videoaufnahmen</b>
// 		</Typography>
// 		<Typography>
// 			<b>Beschreibung und Umfang der Datenverarbeitung:</b> Im Rahmen des besonderen öffentlichen Auftrags, die Wirtschaftsförderung im Land
// 			Hessen zu betreiben und (weiter) zu entwickeln, obliegt es uns, die Öffentlichkeit über Veranstaltungen in geeigneten Publikationen in
// 			Wort und Bild zu informieren. Zu diesem Zweck werden bei Veranstaltungen Foto-, Ton- und Videoaufnahmen gemacht und diese in
// 			Printmedien, eigenen Veröffentlichungen, in unseren Internet-Angeboten und/oder Auftritten in sozialen Medien veröffentlicht. Für die
// 			Anfertigung von Porträt und Nahaufnahmen von Ihnen sowie für die Veröffentlichung aufseiten sozialer Medien holen wir Ihre Einwilligung
// 			ein und verweisen auf diese Datenschutzerklärung.
// 		</Typography>
// 		<Typography>
// 			Rechtsgrundlage für die Datenverarbeitung: Rechtsgrundlage für die Verarbeitung der Foto- und Videoaufnahmen ist der uns übertragene
// 			öffentliche Auftrag der Wirtschaftsförderung in Hessen (Art. 6 Abs. 1 lit. e DS-GVO). Wenn Sie Ihre Einwilligung in die Anfertigung
// 			und/oder Veröffentlichung von Foto-, Ton- und Filmaufnahmen erteilt haben, ist dies die Rechtsgrundlage für die Datenverarbeitung (Art.
// 			6 Abs. 1 lit. a DS-GVO).
// 		</Typography>
// 		<Typography>
// 			<b>Zweck der Datenverarbeitung:</b> Zweck der Veröffentlichung von Foto- und Videoaufnahmen ist unser besonderer öffentlicher Auftrag,
// 			die Wirtschaftsförderung im Land Hessen zu betreiben und (weiter) zu entwickeln und die interessierte Öffentlichkeit daher über
// 			Veranstaltungen zu informieren.
// 		</Typography>
// 		<Typography>
// 			<b>Dauer der Speicherung:</b> Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
// 			erforderlich sind. Soweit Fotos, Tonaufnahmen und Videos nicht veröffentlicht werden, werden diese spätestens einen Monat nach
// 			Beendigung der Veranstaltung gelöscht. Veröffentlichte Fotos, Tonaufnahmen und Videos bleiben gespeichert, solange die jeweiligen
// 			Veröffentlichungen abrufbar oder erhältlich sind.
// 		</Typography>
// 		<Typography>
// 			<b>Empfänger und Datenübermittlung in Drittstaaten:</b> Für die Veröffentlichung in Printmedien werden die aufgenommenen Fotos
// 			insbesondere an Tageszeitungen und Verlagshäuser übermittelt. Sofern Sie im Rahmen der Anmeldung in eine Veröffentlichung Sie zeigender
// 			Fotos und Videos in sozialen Medien eingewilligt haben, werden die Daten an die Betreiber der sozialen Netzwerke übermittelt, bei denen
// 			wir eine Profilseite unterhalten und über die wir ausdrücklich informieren. Die Betreiber sozialer Medien haben ihren Sitz teilweise
// 			außerhalb des Gebietes der EU und des Europäischen Wirtschaftsraumes (EWR), insbesondere in den USA. Diese Länder verfügen zum Teil
// 			nicht über ein der EU entsprechendes Datenschutzniveau oder die Bestätigung der Angemessenheit des Datenschutzniveaus ist von weiteren
// 			Voraussetzungen abhängig (z.B. Zertifizierung der Teilnahme am EU-U.S. Data Privacy Framework). Wir können nicht ausschließen, dass auch
// 			dann, wenn Betreiber sozialer Medien einen Sitz in der EU haben, die personenbezogenen Daten auch an Konzerngesellschaften in den USA
// 			oder einem anderen Land außerhalb der EU oder des EWR übermittelt und/oder diese auch auf Servern in den USA oder einem anderen Land
// 			außerhalb der EU oder des EWR gespeichert werden.
// 		</Typography>
// 		<br></br>
// 		<Typography>9.</Typography>
// 		<Typography>
// 			<b>Anmeldung zu Maßnahmen der Kontaktverknüpfung bei Veranstaltungen</b>{' '}
// 		</Typography>
// 		<Typography>
// 			<b>Beschreibung und Umfang der Datenverarbeitung:</b> Besucherinnen und Besucher haben im Vorfeld bestimmter Veranstaltungen die
// 			Möglichkeit, sich für die Teilnahme an Maßnahmen zur Konktaktverknüpfung (sog. Partnering oder Matchmaking) anzumelden und Profile zu
// 			hinterlegen. Mit Absenden der Anmeldung für das Partnering/Matchmaking und des Profils werden die in den Eingabemasken angegebenen Daten
// 			an uns übermittelt und gespeichert. Im Zeitpunkt der Absendung der Anmeldung werden zudem die von Ihnen verwendete IP-Adresse sowie
// 			Datum und Uhrzeit der Anmeldung gespeichert. Für die Verarbeitung der Daten wird im Rahmen des Absendevorgangs Ihre Einwilligung
// 			eingeholt und auf diese Datenschutzerklärung verwiesen. Bei regelmäßigen Veranstaltungen haben Sie zum Teil die Möglichkeit, Ihr Profil
// 			dauerhaft auch für weitere Veranstaltungen zu hinterlegen. Darauf weisen wir ggf. im Rahmen der Einwilligungserklärung gesondert hin.
// 		</Typography>
// 		<Typography>
// 			Die Bereitstellung der personenbezogenen Daten durch Sie ist freiwillig. Eine Teilnahme am Partnering/Matchmaking ist allerdings nicht
// 			möglich, wenn Sie uns nicht die als Pflichtangaben gekennzeichneten Daten zur Verfügung stellen.
// 		</Typography>
// 		<Typography>
// 			Teilnehmende, die sich für das Partnering/Matchmaking angemeldet haben, erhalten in aller Regel vor der Veranstaltung Zugang zu den
// 			Profilen anderer Teilnehmender und können Kontakt zu diesen aufnehmen.{' '}
// 		</Typography>
// 		<Typography>
// 			<b>Rechtsgrundlage für die Datenverarbeitung:</b> Rechtsgrundlage für die Verarbeitung der Daten ist Ihre Einwilligung (Art. 6 Abs. 1
// 			lit. a DS-GVO).
// 		</Typography>
// 		<Typography>
// 			<b>Zweck der Datenverarbeitung:</b> Die Verarbeitung der personenbezogenen Daten dient ausschließlich der Anmeldung zum und der
// 			Durchführung der Maßnahmen zur verbesserten Kontaktverknüpfung auf Veranstaltungen.
// 		</Typography>
// 		<Typography>
// 			<b>Dauer der Speicherung:</b> Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
// 			erforderlich sind. Die im Rahmen der Anmeldung für das Partnering/Matchmaking im Profil erhobenen personenbezogenen Daten werden
// 			spätestens sechs Monate nach Beendigung der Veranstaltung gelöscht, es sei denn, Sie haben in die längere Speicherung Ihres Profils
// 			eingewilligt.{' '}
// 		</Typography>
// 		<Typography>
// 			Die während des Absendevorgangs zusätzlich erhobenen personenbezogenen Daten werden spätestens nach einer Frist von sieben Tagen
// 			gelöscht.
// 		</Typography>
// 		<br></br>
// 		<Typography>10.</Typography>
// 	</Stack>
// </Stack>
